(function () {
    var i = 0;
    jQuery('.start.car').each(function (index, e) {
        window.setTimeout(function () {
            jQuery('.icon', e).addClass('active');
            jQuery(e).removeClass('start');
        }, i * 400);
        i++;
    });
})();
